export default {
    start: 'brand',
    process: require('./../process/default').default
}



// WEBPACK FOOTER //
// ./src/processes/conf/default.js